export default {
  category: Object.freeze({
    OWN_COMPLEXES: 'own-complexes', DENTAL_LAB_COMPLEXES: 'dental-lab-complexes',
    ARCHIVE_COMPLEXES: 'archive-complexes', OWN_COMPLEXES_LABEL: 'Наши комплексы',
    DENTAL_LAB_COMPLEXES_LABEL: 'Зуботехническая лаборатория', ARCHIVE_COMPLEXES_LABEL: 'Архивные комплексы'
  }),
}
